"use client";

import { useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { createPack } from "@/lib/actions/packs";
import { Spinner } from "@/components/Spinner";

export function NewPackButton() {
  const router = useRouter();
  const [pending, start] = useTransition();
  const [error, setError] = useState(false);

  function create() {
    start(async () => {
      setError(false);
      try {
        const res = await createPack("Untitled pack");
        if (res.ok && res.slug) router.push(`/packs/${res.slug}/edit`);
        else setError(true);
      } catch {
        setError(true);
      }
    });
  }

  return (
    <div className="flex flex-col items-end gap-1.5">
      <button
        onClick={create}
        disabled={pending}
        className="flex h-[44px] items-center gap-2 rounded-[22px] bg-green px-5 text-[14px] font-bold text-surface disabled:opacity-60"
        style={{ boxShadow: "var(--shadow-cta)" }}
      >
        {pending && <Spinner size={15} />}
        {pending ? "Creating…" : "+ New pack"}
      </button>
      {error && (
        <span className="text-[12.5px] font-semibold text-danger" role="alert">
          Couldn&apos;t create a pack — try again.
        </span>
      )}
    </div>
  );
}
